// extracted by mini-css-extract-plugin
export default {"area":"area__28zO-","fullHeight":"fullHeight__3V9cx","hidden":"hidden__10Hkz"};